import { createSelector } from 'reselect';

export const currentPageSelector = createSelector(
  (state) => state.purchaseOrders.ui.currentPage,
  (currentPage) => {
    return currentPage;
  }
);

export const createFormSelector = createSelector(
  (state) => state.purchaseOrders.ui.createForm,
  (createForm) => {
    return createForm;
  }
);

export const purchaseOrdersSelector = createSelector(
  (state) => state.purchaseOrders.data.purchaseOrders,
  (purchaseOrders) => {
    return purchaseOrders;
  }
);

export const showCreateModalSelector = createSelector(
  (state) => state.purchaseOrders.ui.showCreateModal,
  (showCreateModal) => {
    return showCreateModal;
  }
);



// WEBPACK FOOTER //
// ./src/components/admin/purchase-orders/store/selectors.js